module.exports = __webpack_public_path__ + "img/notif1.a83e708c.png";